// Lectura del plan del cliente. Si no hay membresia a la mano no se bloquea nada: quien
// recorta de verdad es la API, aqui solo se le evita al cliente entrar a algo que le van
// a negar.
export const featuresOf = membership => membership?.features || {}

export const usageOf = membership => membership?.usage || {}

export const allows = (membership, featureKey) => featuresOf(membership)[featureKey] !== false

// Un limite vacio es ilimitado. El uso viene del backend, no se cuenta en el front.
export const limitReached = (membership, featureKey) => {
  const limit = featuresOf(membership)[featureKey]
  if (limit === null || limit === undefined || limit === '') return false

  return Number(usageOf(membership)[featureKey] || 0) >= Number(limit)
}

// Pantallas que dependen de un interruptor del plan. El menu las sigue mostrando y el
// cliente llega a la ruta; MembershipGate pone el aviso en lugar de la vista.
export const FEATURE_BY_ROUTE = {
  allMyExpenses: 'purchase_management',
  allExpenses: 'purchase_management',
  expenses: 'purchase_management',
  newExpense: 'purchase_management',
  expensesByGroup: 'purchase_management',
  groupedExpenses: 'budgets_access',
  addGroupedExpenses: 'budgets_access',
  budget: 'budgets_access',
  incomes: 'income_tracking',
  newIncome: 'income_tracking',
  editIncome: 'income_tracking',
  reports: 'reports_access',
  incomesVsExpenses: 'reports_access',
  expensesReport: 'reports_access',
}

// Pantallas de alta que dependen de un cupo. Se bloquean al llegar al tope, no al enviar
// el formulario.
export const LIMIT_BY_ROUTE = {
  'new-member': 'max_users',
  newProjects: 'active_projects',
}

export const lockForRoute = (membership, routeName) => {
  if (!membership) return null

  const featureKey = FEATURE_BY_ROUTE[routeName]
  if (featureKey && !allows(membership, featureKey)) {
    return { featureKey, kind: 'feature' }
  }

  const limitKey = LIMIT_BY_ROUTE[routeName]
  if (limitKey && limitReached(membership, limitKey)) {
    return { featureKey: limitKey, kind: 'limit' }
  }

  return null
}

export default {
  featuresOf,
  usageOf,
  allows,
  limitReached,
  FEATURE_BY_ROUTE,
  LIMIT_BY_ROUTE,
  lockForRoute,
}
